import { render, staticRenderFns } from "./PiechartVolumePerProduk.vue?vue&type=template&id=310d8036"
import script from "./PiechartVolumePerProduk.vue?vue&type=script&lang=js"
export * from "./PiechartVolumePerProduk.vue?vue&type=script&lang=js"
import style0 from "./PiechartVolumePerProduk.vue?vue&type=style&index=0&id=310d8036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports